'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Box } from '@s7/base';
import { useProps } from '@s7/styles';
import { useInputRootContext } from '../InputRoot.context.js';
import { IDENT_INPUT_LABEL, defaultProps } from './InputLabel.contract.js';
import useStyles from './InputLabel.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const InputLabel = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { __withStaticSelectors = false, required } = _param, props = _object_without_properties_loose(_param, [
        "__withStaticSelectors",
        "required"
    ]);
    const _useProps = useProps(IDENT_INPUT_LABEL, props, defaultProps), [{ labelElement, children, className, htmlFor, icon, onMouseDown, color }, sxs] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "labelElement",
        "children",
        "className",
        "htmlFor",
        "icon",
        "onMouseDown",
        "color"
    ]);
    const context = useInputRootContext();
    const [classes, cx] = useStyles({
        required: required != null ? required : context.required,
        color
    }, _extends({}, sxs, {
        __withStaticSelectors
    }), IDENT_INPUT_LABEL);
    const handleMouseDown = (event)=>{
        onMouseDown == null ? void 0 : onMouseDown(event);
        if (!event.defaultPrevented && event.detail > 1) {
            event.preventDefault();
        }
    };
    return /*#__PURE__*/ jsxs(Box, _extends({
        ref: ref,
        as: labelElement,
        className: cx(classes.label, className),
        htmlFor: labelElement === 'label' ? htmlFor : undefined,
        onMouseDown: handleMouseDown
    }, others, {
        children: [
            /*#__PURE__*/ jsx("div", {
                className: cx(classes.labelText),
                children: children
            }),
            icon && /*#__PURE__*/ jsx("div", {
                className: classes.labelIcon,
                children: icon
            })
        ]
    }));
});
InputLabel.displayName = IDENT_INPUT_LABEL;

export { InputLabel };
//# sourceMappingURL=InputLabel.js.map
